"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerSelectorStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        container: (_b = {
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
            },
            _b[breakpoints.down('sm')] = {
                flexDirection: 'column-reverse',
                flexWrap: 'wrap',
            },
            _b),
        actionButtonsContainer: {
            margin: '40px 0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    });
}, { name: 'GqlCheckout_DealerSelector' });
exports.default = dealerSelectorStyles;
